import React from 'react';
import PropTypes from 'prop-types';

const BlazeSecondName = ({ register }) => (
  <input
    type="text"
    name="blazeSecondName"
    className="blaze-second-name-field"
    aria-hidden="true"
    autoComplete="off"
    tabIndex="-1"
    {...register('blazeSecondName')}
  />
);

BlazeSecondName.propTypes = {
  register: PropTypes.func.isRequired
};

export default BlazeSecondName;
